"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const useRateLimiter = require("./useRateLimiter.cjs");
function useRateLimitedState(value, options, selector) {
  const [rateLimitedValue, setRateLimitedValue] = react.useState(value);
  const rateLimiter = useRateLimiter.useRateLimiter(setRateLimitedValue, options, selector);
  return [rateLimitedValue, rateLimiter.maybeExecute, rateLimiter];
}
exports.useRateLimitedState = useRateLimitedState;
//# sourceMappingURL=useRateLimitedState.cjs.map
